import React, { ReactNode } from 'react';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { mantineTheme, cssVariablesResolver } from '@srm/ui/theme';
import { UiProvider } from '@srm/ui/provider';
import { sendNotification } from '@srm/ui/lib/notifications';
import { colorSchemeManager, DEFAULT_COLOR_SCHEME } from './colorSchemeStorage';

// Единая точка конфигурации Mantine. Помимо корня приложения используется в фолбэке
// AppErrorBoundary: фолбэк рендерится вместо выкинутого дерева, вместе с которым уходит и
// корневой провайдер, а ErrorPage собран из Mantine-фасадов (@atoms/Button и др.).
// Цветовая схема: Mantine владеет атрибутом data-mantine-color-scheme на <html>, значение
// хранит colorSchemeManager (localStorage, ключ и дефолт — в colorSchemeStorage).
export const AppMantineProvider: React.FC<{ children: ReactNode }> = ({ children }) => (
    <MantineProvider
        theme={mantineTheme}
        cssVariablesResolver={cssVariablesResolver}
        colorSchemeManager={colorSchemeManager}
        defaultColorScheme={DEFAULT_COLOR_SCHEME}
    >
        <DatesProvider settings={{ locale: 'ru', firstDayOfWeek: 1, consistentWeeks: true }}>
            <UiProvider notify={sendNotification}>{children}</UiProvider>
        </DatesProvider>
    </MantineProvider>
);
